import useAuthUser from "../../hooks/useAuthUser";
import OrganizationCard from "./OrganizationCard";

const OrganizationReportees = ({
  managerName,
  people,
  photoPath = "",
  onClick = () => {},
  highlightedUserId = null,
}) => {
  const { loggedInUser } = useAuthUser();
  const loggedInUserId = Number(loggedInUser?.id);
  const loggedInUserRole = Number(loggedInUser?.role);
  const isManagerRole =
    loggedInUserRole === 8 || loggedInUserRole === 4 || loggedInUserRole === 5;
  const isEmployeeRole = loggedInUserRole === 7;
  return (
    <div className="more-people-box">
      <div className="heading">
        People reporting to {managerName} ({people.length})
      </div>
      <div className="content">
        {people.map((person) => {
          let canClick = null;
          if (isManagerRole || isEmployeeRole) {
            if (
              person.userId === loggedInUserId ||
              person.reportingManagerId === loggedInUserId
            ) {
              canClick = onClick;
            }
          } else {
            canClick = onClick;
          }
          return (
            <OrganizationCard
              key={person.userId}
              user={person}
              photoPath={photoPath}
              onClick={canClick}
              highlightedUserId={highlightedUserId}
            />
          );
        })}
      </div>
    </div>
  );
};

export default OrganizationReportees;
